import React from 'react';
import _ from 'lodash';
import { formats } from '~/helper';
 import { Formik } from 'formik';
import { InputLabel, Select } from '~/components/form';
import { Card, DetailContainer, Row } from '~/views/events/matchday/styles';

function Details({ model, goToPersons, changeStatus }) {
  return (
    <DetailContainer>
      <InputLabel
        noMargin={true}
        label='Tipo'
        value={_.get(model, 'event.eventType.name')}
        />

      <InputLabel
        noMargin={true}
        label='Gerente'
        value={_.get(model, 'event.manager.name')}
        />

      <InputLabel
        noMargin={true}
        label='Local'
        value={_.get(model, 'event.place.name')}
        />

      <Formik>
        <Select
          name="status"
          label="Fase"
          value={_.get(model, 'event.status')}
          options={{ values: [
            { value: 'checklist', label: 'Checklist' },
            { value: 'running', label: 'Match Day' },
          ]}}
          onChange={(evt) => changeStatus(_.get(model, 'event.id'), evt.target.value)}
          />
      </Formik>

      <Row span={2}>
        <InputLabel
          noMargin={true}
          label='Data do Evento'
          value={formats.dateTimeZone(_.get(model, 'event.eventDate'), 'dd/MM/yyyy  HH:mm')}
          />

        <InputLabel
          noMargin={true}
          label='Data de término do Evento'
          value={formats.dateTimeZone(_.get(model, 'event.eventEndDate'), 'dd/MM/yyyy HH:mm')}
          />
      </Row>

      <Card color='#d00db7'>
        <span className='title'>Fornecedores</span>
        <div className='value'>
          {formats.number(_.get(model, 'cards.suppliers.total'))}
        </div>
      </Card>

      <Card color='#0dd0cc'>
        <span className='title'>Colaboradores</span>
        <div className='value'>
          {formats.number(_.get(model, 'cards.persons.total'))}
        </div>
      </Card>

      <Card color='#0d37d0'>
        <span className='title'>P-COVID</span>
        <div className='value'>
          {formats.number(_.get(model, 'cards.persons.pcovid'))}
        </div>
      </Card>
     
      <Card color='#fd9006d9'>
        <span className='title'>Check-ins</span>
        <div className='value'>
          {formats.number(_.get(model, 'cards.persons.checkin'))}
        </div>
      </Card>

      <Card color='#00bb00d9'>
        <span className='title'>Check-outs</span>
        <div className='value'>
          {formats.number(_.get(model, 'cards.persons.checkout'))}
        </div>
      </Card>

      <Card color='#bb0000d9'>
        <span className='title'>Valor Total</span>
        <div className='value'>
          {formats.currency(_.get(model, 'cards.total'))}
        </div>
      </Card>
    </DetailContainer>
  );
}

export default Details;
